module.exports = __webpack_public_path__ + "static/employee-time-clock-app-465ae8019c300206616ea5357a55f0a4.png";